<template>
  <div class="panier" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
    <router-link tag="a" :to="{name: 'step4'}" v-if="cartCount > 0" class="grid-text">
      <svg height="512pt" class="cart--icon"  viewBox="0 -18 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg">
        <path fill="#FFF"
              d="m164.960938 300.003906h.023437c.019531 0 .039063-.003906.058594-.003906h271.957031c6.695312 0 12.582031-4.441406 14.421875-10.878906l60-210c1.292969-4.527344.386719-9.394532-2.445313-13.152344-2.835937-3.757812-7.269531-5.96875-11.976562-5.96875h-366.632812l-10.722657-48.253906c-1.527343-6.863282-7.613281-11.746094-14.644531-11.746094h-90c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h77.96875c1.898438 8.550781 51.3125 230.917969 54.15625 243.710938-15.941406 6.929687-27.125 22.824218-27.125 41.289062 0 24.8125 20.1875 45 45 45h272c8.285156 0 15-6.714844 15-15s-6.714844-15-15-15h-272c-8.269531 0-15-6.730469-15-15 0-8.257812 6.707031-14.976562 14.960938-14.996094zm312.152343-210.003906-51.429687 180h-248.652344l-40-180zm0 0"/>
        <path fill="#FFF"
              d="m150 405c0 24.8125 20.1875 45 45 45s45-20.1875 45-45-20.1875-45-45-45-45 20.1875-45 45zm45-15c8.269531 0 15 6.730469 15 15s-6.730469 15-15 15-15-6.730469-15-15 6.730469-15 15-15zm0 0"/>
        <path fill="#FFF"
              d="m362 405c0 24.8125 20.1875 45 45 45s45-20.1875 45-45-20.1875-45-45-45-45 20.1875-45 45zm45-15c8.269531 0 15 6.730469 15 15s-6.730469 15-15 15-15-6.730469-15-15 6.730469-15 15-15zm0 0"/>
      </svg>
      <span class="label">{{cartCount | numberMax}}</span>
    </router-link>
    <a href="javascript:void(0)" v-else class="grid-text">
      <svg height="512pt" class="cart--icon" viewBox="0 -18 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg">
        <path fill="#FFF"
              d="m164.960938 300.003906h.023437c.019531 0 .039063-.003906.058594-.003906h271.957031c6.695312 0 12.582031-4.441406 14.421875-10.878906l60-210c1.292969-4.527344.386719-9.394532-2.445313-13.152344-2.835937-3.757812-7.269531-5.96875-11.976562-5.96875h-366.632812l-10.722657-48.253906c-1.527343-6.863282-7.613281-11.746094-14.644531-11.746094h-90c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h77.96875c1.898438 8.550781 51.3125 230.917969 54.15625 243.710938-15.941406 6.929687-27.125 22.824218-27.125 41.289062 0 24.8125 20.1875 45 45 45h272c8.285156 0 15-6.714844 15-15s-6.714844-15-15-15h-272c-8.269531 0-15-6.730469-15-15 0-8.257812 6.707031-14.976562 14.960938-14.996094zm312.152343-210.003906-51.429687 180h-248.652344l-40-180zm0 0"/>
        <path fill="#FFF"
              d="m150 405c0 24.8125 20.1875 45 45 45s45-20.1875 45-45-20.1875-45-45-45-45 20.1875-45 45zm45-15c8.269531 0 15 6.730469 15 15s-6.730469 15-15 15-15-6.730469-15-15 6.730469-15 15-15zm0 0"/>
        <path fill="#FFF"
              d="m362 405c0 24.8125 20.1875 45 45 45s45-20.1875 45-45-20.1875-45-45-45-45 20.1875-45 45zm45-15c8.269531 0 15 6.730469 15 15s-6.730469 15-15 15-15-6.730469-15-15 6.730469-15 15-15zm0 0"/>
      </svg>
    </a>

    <transition name="cart-fade">
      <div class="panier--popunder" v-if="openState">
        <div class="cart--header">
          <div class="cart--header-count">
          <span class="cart-icon">
            <i class="la la-shopping-cart"></i>
          </span>
            <span class="cart--number">{{cartCount}}</span>
          </div>
          <div class="cart--header-total">
            <span class="total-str">{{$t('mobileMenu.total')}}</span>
            <span class="total-amount">{{total | decimalPrice}} €</span>
          </div>
        </div>
        <div class="cart--body" v-if="loading">
          <div class="loader">
            <loader/>
          </div>
        </div>
        <div class="cart--body" v-else-if="cartCount > 0">
          <div class="room-wrapper" v-for="(item, index) in rooms" :index="index" :key="item.id" :item="item">
            <cart-room :item="item"/>
          </div>
        </div>
        <div class="cart--body" v-else>
          <span class="empty">{{$t('mobileMenu.empty')}}</span>
        </div>
        <div class="cart--footer" v-if="cartCount > 0">
          <router-link
            tag="div"
            :to="{name: 'step4'}"
            class="btn btn-primary btn-full btn-std btn-cart">
            {{$t('mobileMenu.order')}}
          </router-link>
        </div>
      </div>
    </transition>
  </div>
</template>

<style scoped>
  .panier--popunder {
    position: absolute;
    background: var(--black);
    right: -24px;
    top: 24px;
    color: var(--white);
    width: 320px;
    padding: 1rem;
    z-index: 151;
    overflow: hidden;
  }
  .loader {
    height: 60px;
  }

  .cart--body {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(1fr);
    grid-gap: 1rem;
  }

  .cart--body .room-wrapper {
    transition: all 300ms ease;
    padding: 20px 10px 30px 10px;
    margin: -20px -10px -30px -10px;
    position: relative;
    z-index: 10;
  }

  .cart--body .room-wrapper:hover {
    background: #c15842;
    box-shadow: 0 0 40px 5px rgba(0, 0, 0, 1);
    z-index: 11;
  }

  .cart--header {
    display: grid;
    grid-template: "1fr 1fr";
    align-items: center;
    padding-bottom: 1rem;
    border-bottom: 1px solid rgba(255, 255, 255, .2);
    margin-bottom: 1rem;
  }

  .cart--footer .btn {
    margin-top: 0 !important;
  }

  .cart--footer {
    padding-top: 1rem;
    border-top: 1px solid rgba(255, 255, 255, .2);
    margin-top: 1rem;
    grid-gap: 1rem;
  }

  .cart--header .cart--header-count {
    display: flex;
    flex-wrap: nowrap;
  }

  .cart--header .cart--header-total {
    text-align: right;
  }

  .cart--header .cart--number {
    flex: 0 0 auto;
    margin: auto auto auto 0;
    background: #c15842;
    display: inline-block;
    padding: 2px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
  }

  .cart--header .cart--header-total .total-str {
    color: #a2acb2;
  }

  .cart--header .cart--header-total .total-amount {
    color: #c15842;
    font-weight: 600;
  }

  .cart--header .cart--header-count .cart-icon i {
    font-size: 28px;
  }
</style>

<script>
  import { mapState } from 'vuex';
  import CartRoom from './cart-room';
  import Loader from '../loader.component';

  export default {
    name: 'cart',
    components: { Loader, CartRoom },
    computed: {
      loading() {
        return this.$store.getters["shoppingCart/loading"];
      },
      cartCount() {
        return this.$store.getters["shoppingCart/cartCount"];
      },
      rooms() {
        return this.$store.getters["shoppingCart/rooms"]
      },
      total() {
        return this.$store.getters["shoppingCart/totalPrice"];
      },
    },
    watch: {
      cartCount (v, oldV) {
        if (v < oldV) this.openState = false;
      }
    },
    methods: {
      handleMouseEnter () {
        this.openState = true;
      },
      handleMouseLeave () {
        this.openState = false;
      }
    },
    data() {
      return {
        openState: false
      };
    }
  };
</script>





// WEBPACK FOOTER //
// src/components/topbar/cart.vue